import axios from 'axios';

// Single shared axios instance for all API calls — baseURL and credentials are
// configured once here instead of being re-declared in every component.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true
});

export default api;
